import { DateFields } from '@/components/ui/date-fields/DateFields';
import { DateInfo } from '@/utils/date/types';

interface DatePickerProps {
  value: DateInfo | undefined;
  onChange: (date: DateInfo | undefined) => void;
  error?: string;
  showSwitchInLabel?: boolean;
  inlineSwitch?: boolean;
}

export function DatePicker({ 
  value, 
  onChange, 
  error, 
  showSwitchInLabel = false,
  inlineSwitch = false 
}: DatePickerProps) {
  return (
    <DateFields
      value={value}
      onChange={onChange}
      error={error}
      required={true}
      showSwitchInLabel={showSwitchInLabel}
      inlineSwitch={inlineSwitch}
    />
  );
}